import React, { useState } from "react";
import { selezionaLivello } from "../services/api";
import { updateSubscription, upgradeSubscription } from '../services/api_subscriptions';
import Swal from "sweetalert2";

const ModalUpdateSubscription = ({
    mode,
    selectedPlan,
    employeeCount,
    newQuantity,
    selectedPrice,
    onClose,
    token,
    duration,
    newPrice,
    onUpdateQuantity,
    subscriptionIdtoUpgrade,
    planUpgrade,
}) => {
    const [couponCode, setCouponCode] = useState("");
    const [couponError, setCouponError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 rounded-lg">
            <div className="bg-white rounded-lg p-0 w-1/2">
                <div className="sticky top-0 z-20">
                    <h1 className="text-center text-lg bg-indigo-100 p-2 font-semibold text-indigo-800 rounded-t-lg">
                        Riepilogo {['updateSubscription', 'upgradeSubscription'].includes(mode) ? 'Aggiornamento Sottoscrizione' : 'Nuova Sottoscrizione'}
                    </h1>
                </div>
                <div className="p-4">
                    {(mode === 'newSubscription' || mode === 'upgradeSubscription') ? (
                        <p className="pb-2 text-gray-800 font-medium">
                            <strong className="text-indigo-800">Piano selezionato:</strong> <span className="uppercase">{selectedPlan?.name}</span>
                        </p>
                    ) : mode === 'updateSubscription' ? (
                        <p className="pb-2 text-gray-800 font-medium">
                            <strong className="text-indigo-800">Piano:</strong> {
                                selectedPlan?.plan?.name || 'Nessun piano trovato'
                            }
                        </p>
                    ) : null}

                    <p className="pb-2 text-gray-800 font-medium">
                        <strong className="text-indigo-800">Numero di Dipendenti: </strong> 
                        {['newSubscription', 'upgradeSubscription'].includes(mode) ? employeeCount 
                        : mode === 'updateSubscription' ? 
                        (newQuantity?.quantity) : null}
                    </p>

                    {mode === 'newSubscription' ? (
                        <p className="pb-2 text-gray-800 font-medium">
                            <strong className="text-indigo-800">Periodicità rinnovo:</strong> {duration === 'year' ? 'Annuale' : 'Mensile'}
                        </p>
                    ) : mode === 'upgradeSubscription' ? (
                        <p className="pb-2 text-gray-800 font-medium">
                            <strong className="text-indigo-800">Periodicità rinnovo:</strong> {
                                selectedPlan?.duration === 'month' ? 'Mensile' : 'Annuale'
                            }
                        </p>
                    ) : mode === 'updateSubscription' ? (
                        <p className="pb-2 text-gray-800 font-medium">
                            <strong className="text-indigo-800">Periodicità rinnovo:</strong> {
                                selectedPlan?.plan?.duration_months === 1 ? 'Mensile' : 'Annuale'
                            }
                        </p>
                    ) : null}

                    {mode === 'newSubscription' && (
                        <>
                            <div className="flex items-center pb-2 text-gray-800 font-medium">
                                <strong className="text-indigo-800">Coupon:</strong>
                                <input
                                    type="text"
                                    value={couponCode}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setCouponCode(value);
                                        if (value === "") {
                                            setCouponError("");
                                        }
                                    }}
                                    className={`border rounded-md w-full text-xs ml-4 p-2 focus:ring-indigo-600 ${
                                        couponError ? "border-red-500" : "border-gray-200"
                                    }`}
                                    placeholder="Se possiedi un coupon, inserisci qui il codice"
                                />
                            </div>
                            {couponError && (
                                <p className="text-red-500 text-xs ml-28 mb-2">{couponError}</p>
                            )}
                        </>
                    )}

                    <p className="pb-2 text-gray-800 font-medium">
                        {['newSubscription', 'upgradeSubscription'].includes(mode) ? (
                            <>
                                <strong className="text-indigo-800">Prezzo:</strong> € {selectedPrice || 0} + IVA
                                {mode === 'upgradeSubscription' && (
                                    <>
                                    <br/>
                                        <span className="text-sm">Il prezzo indicato verrà addebitato dalla prossima fattura prevista alla data del rinnovo.</span><br />
                                    
                                        <span className="text-sm">La modifica del piano avrà effetto immediato. Eventuali coupon esistenti saranno applicati e eventuali debiti o crediti saranno inclusi nella prossima fattura.</span>
                                   </>
                                )}
                            </>
                        ) : (
                            <>
                                <strong className="text-indigo-800">Prezzo:</strong> € {newPrice?.discounted || 0} + IVA <br /><br />
                                <span className="text-sm">Il prezzo indicato verrà addebitato dalla prossima fattura prevista alla data del rinnovo.</span><br /><br />
                                {selectedPlan?.quantity > newQuantity?.quantity ? (
                                    <span className="text-sm">Il prezzo delle licenze eliminate e già pagate verrà sottratto nella prossima fattura.</span>
                                ) : (
                                    <span className="text-sm">Il prezzo delle licenze aggiunte, fino alla data del prossimo rinnovo, verrà addebitato alla conferma sul metodo di pagamento salvato. Eventuali coupon già presenti verranno applicati.</span>
                                )}
                            </>
                        )}
                    </p>
                </div>

                <div className="flex justify-center mb-4">
                    <button 
                        className={`inline-flex items-center justify-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 me-3 w-28 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        onClick={async () => {
                            setIsLoading(true);
                            setCouponError("");
                            try {
                                if (mode === "newSubscription") {
                                    const response = await selezionaLivello(token, selectedPlan?.id, employeeCount, couponCode || null);
                                    if (response.url) {
                                        window.location.href = response.url;
                                    } else {
                                        console.error("URL di pagamento non trovato nella risposta");
                                    }
                                } else if (mode === "updateSubscription") {
                                    const subscriptionId = selectedPlan?.id;
                        
                                    if (!subscriptionId) {
                                        throw new Error("ID della subscription non trovato");
                                    }
                                    
                                    Swal.fire({
                                        title: "Aggiornamento in corso...",
                                        text: "Attendi mentre aggiorniamo la sottoscrizione.",
                                        icon: "info",
                                        allowOutsideClick: false,
                                        showConfirmButton: false,
                                        willOpen: () => {
                                            Swal.showLoading();
                                        },
                                    });
                        
                                    const response = await updateSubscription(
                                        token,
                                        subscriptionId,
                                        newQuantity.quantity
                                    );
                                    
                                    Swal.fire({
                                        title: "Sottoscrizione aggiornata!",
                                        text: `La sottoscrizione è stata aggiornata con successo alla quantità ${newQuantity?.quantity}.`,
                                        icon: "success",
                                        confirmButtonText: "OK",
                                    }).then(() => {
                                        onUpdateQuantity(newQuantity.quantity);
                                    });
                                } else if (mode === "upgradeSubscription") {                             
                                    const subscriptionId = subscriptionIdtoUpgrade;
                                    const planCode = planUpgrade;

                                    
                                    if (!subscriptionId || !planCode) {
                                        throw new Error("ID della subscription o codice del piano non trovato");
                                    }
                    
                                    Swal.fire({
                                        title: "Aggiornamento in corso...",
                                        text: "Attendi mentre eseguiamo l'upgrade della sottoscrizione.",
                                        icon: "info",
                                        allowOutsideClick: false,
                                        showConfirmButton: false,
                                        willOpen: () => {
                                            Swal.showLoading();
                                        },
                                    });
                    
                                    const response = await upgradeSubscription(token, subscriptionId, planCode);
                    
                                    Swal.fire({
                                        title: "Upgrade completato!",
                                        text: `La sottoscrizione è stata aggiornata al piano ${selectedPlan?.name}.`,
                                        icon: "success",
                                        confirmButtonText: "OK",
                                    });
                                } 
                                
                            } catch (error) {
                                if (error.response?.data?.error?.includes("No such coupon")) {
                                    setCouponError("Il coupon inserito non è valido");
                                } else if (error.response?.data) {
                                    console.error("Errore durante l'operazione", error);
                                    
                                    const errorMessages = Object.values(error.response.data)
                                        .flat()
                                        .join(', ');
                            
                                    Swal.fire({
                                        icon: "error",
                                        title: "Oops...",
                                        text: errorMessages || "Si è verificato un errore durante l'aggiornamento della sottoscrizione.",
                                    });
                                } else {
                                    console.error("Errore generico durante l'operazione", error);
                            
                                    Swal.fire({
                                        icon: "error",
                                        title: "Oops...",
                                        text: "Si è verificato un errore durante il salvataggio.",
                                    });
                                }
                            } finally {
                                setIsLoading(false);
                                onClose();
                            }
                        }}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Caricamento...' : 'Conferma'}
                    </button>
                    <button 
                        className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600 w-28 hover:bg-gray-100"
                        onClick={onClose}
                    >
                        Annulla
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalUpdateSubscription;
